import algoliasearch, { SearchClient } from 'algoliasearch/lite';

export type SearchClientType = SearchClient | null;

export function getSearchClient(): SearchClientType {
   return App.algoliaConfig?.appId
      ? algoliasearch(App.algoliaConfig.appId, App.algoliaConfig.apiKey)
      : null;
}
